import { ApiError } from '@/api/http/types'
import { lockoutFromApiError } from './lockout'
import { SP_OTP_SEND_FAILED_MESSAGE } from './otp-messages'

/** Network / unreachable API — toast on verify/resend (not inline under OTP). */
export function isNetworkFailure(error: ApiError): boolean {
  return (
    error.code === 'network_error' ||
    error.status === 0 ||
    error.status >= 500 ||
    /^request failed with status code/i.test(error.message) ||
    /^network error$/i.test(error.message)
  )
}

export function isNetworkFailureError(error: unknown): boolean {
  if (error instanceof ApiError) {
    return isNetworkFailure(error)
  }
  if (
    error instanceof Error &&
    (/^request failed with status code/i.test(error.message) ||
      /^network/i.test(error.message))
  ) {
    return true
  }
  return false
}

/** Inline OTP errors only — incorrect code, expiry, session invalid (not network). */
export function resolveOtpInlineErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message
  }
  return 'An unexpected error occurred. Please try again.'
}

/** Network/API OTP delivery failures — toast, not inline (BFP-264 TC-SPW2-13). */
export function isOtpDeliveryFailure(error: unknown): boolean {
  if (!(error instanceof ApiError)) {
    return true
  }
  const lockout = lockoutFromApiError(error)
  if (lockout && (error.status === 403 || error.status === 429)) {
    return false
  }
  return true
}

export function resolveOtpSendFailureMessage(error: unknown): string {
  if (error instanceof ApiError && error.message === SP_OTP_SEND_FAILED_MESSAGE) {
    return error.message
  }
  if (isNetworkFailureError(error) || isOtpDeliveryFailure(error)) {
    return SP_OTP_SEND_FAILED_MESSAGE
  }
  return SP_OTP_SEND_FAILED_MESSAGE
}
